import Vue from 'vue';
export default Vue.extend({
    props: {
        aClass: {
            type: String,
        },
        medium: Boolean,
        small: Boolean,
        width: {
            type: String,
            default: '85px',
        },
    },
});
